import * as ActionTypes from 'constants';


export const beginInitUsersTasks = () => ({ type: ActionTypes.BEGIN_FETCH_USERS_TASKS });
export const initTasks = tasks => ({ type: ActionTypes.INIT_TASKS, payload: tasks });
export const toggleInitializingTasks = bool => ({ type: ActionTypes.TOGGLE_INITIALIZING_TASKS, payload: bool });
export const addNewTask = task => ({ type: ActionTypes.ADD_NEW_TASK, payload: task });
export const addNewTaskAssignedToMe = task => ({ type: ActionTypes.ADD_NEW_TASK_ASSIGNED_TO_ME, payload: task });
export const addNewTaskAssignedByMe = task => ({ type: ActionTypes.ADD_NEW_TASK_ASSIGNED_BY_ME, payload: task });
export const deleteTask = task_id => ({ type: ActionTypes.DELETE_TASK, payload: { task_id } });
export const initTasksAssignedToMe = tasks => ({ type: ActionTypes.INIT_TASKS_ASSIGNED_TO_ME, payload: tasks });
export const initTasksAssignedByMe = tasks => ({ type: ActionTypes.INIT_TASKS_ASSIGNED_BY_ME, payload: tasks });
export const toggleUpdatingTask = bool => ({ type: ActionTypes.TOGGLE_UPDATING_TASK, payload: bool });
export const requestUpdateTask = task => ({ type: ActionTypes.REQUEST_UPDATE_TASK, payload: task });
export const updateTask = task => ({ type : ActionTypes.UPDATE_TASK, payload : task });

// ********************************************************************************** //
// ********************************************************************************** //
// ***************************** OLD TASKS STUFF ************************************ //
// ********************************************************************************** //
// ********************************************************************************** //

export const addTask = (name) => {
	return {
		type : ActionTypes.ADD_TASK,
		task : {
			name,
			progress : 0,
			id : Date.now()
		}
	}
}

export const removeTask = (id) => {
	return {
		type : ActionTypes.REMOVE_TASK,
		id
	}
}

export const updateTaskProgress = (id, progress) => {
	return {
		type : ActionTypes.UPDATE_TASK_PROGRESS,
		id,
		progress
	}
}

export const updateTaskStatus = (id, status) => {
	return {
		type : ActionTypes.UPDATE_TASK_STATUS,
		id,
		status
	}
}

export const taskLoading = (id) => {
	return updateTaskStatus(id, "LOADING");
}

export const taskFailed = (id) => {
	return updateTaskStatus(id, "FAILED");
}

export const taskDone = (id) => {
	return updateTaskStatus(id, "DONE");
}

//Input: A task to perform. {id, name}
//Output: callback(progressHandler, success, fail) //Progress handler designed to interface with fetch(option.progressHandler)
export const createTask = (name, callback) => {
	return (dispatch, getState) => {

		const delayedRemoval = (id) => {
			setTimeout(()=>{
				dispatch(removeTask(id));
			}, 10000);
		}

		var taskAction = addTask(name);
		dispatch(taskAction);
		dispatch(taskLoading(taskAction.task.id)); //Task is officially loading...
		if(callback) //callback(progress, success, fail)
			callback(handleProgress(taskAction.task.id), () => {
				dispatch(updateTaskProgress(taskAction.task.id, 1));
				dispatch(taskDone(taskAction.task.id));
				delayedRemoval(taskAction.task.id);
			},
			() => {
				dispatch(taskFailed(taskAction.task.id));
				delayedRemoval(taskAction.task.id);
			} );
		else {
			console.warn("You must specify a callback.");
		}
	}
}

//Returns function that is called by the progress method of the ajax fetch.
export const handleProgress = (id) => {
	return (progress, e, dispatch, getState) => {
		if(progress < 1)
			dispatch(updateTaskProgress(id, progress));
		else
		{
			dispatch(updateTaskProgress(id, progress));
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/actions/tasks.js